import React from 'react';

import { Badge } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { updateReportCount } from '../actions/AsyncTaskReportAction';
import { useAsync } from 'react-use';
import { fetchAPI } from '../utils/api';

const ReportLabel = () => {
  const dispatch = useDispatch();
  const reportCounter = useSelector((state: any) => state.report.counter);

  useAsync<void>(async () => {
    try {
      const { counter } = await fetchAPI('reports/async-task-report/counter');
      dispatch(updateReportCount(counter));
    } catch (e) {}
  });
  return (
    <>
      <span>Report</span>
      <Badge count={reportCounter} offset={[60, 0]} />
    </>
  );
};

export default ReportLabel;
